import { render, staticRenderFns } from "./StudyQuizQuestionBasicInfo.vue?vue&type=template&id=1e8fe546"
import script from "./StudyQuizQuestionBasicInfo.vue?vue&type=script&lang=js"
export * from "./StudyQuizQuestionBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports